import * as $ from "jquery";
import * as _ from "lodash";
import * as moment from "moment-timezone";
import "select2";
import { ModuleCollection } from "../../../../collections/Modules";
import { TimezoneCollection } from "../../../../collections/Timezones";
import { Utils } from "../../../../common/utils";
import { DashboardChannel } from "../../../../models/DashboardChannel";
import { CHART_DATA_RANGE, DAILY_TIME_MODE } from "../../../dashboard/widgets/chart/ChartHelper";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions
} from "../../dashboard/modify_widgets/_BaseModifyWidgetView";

declare var App: any;


export class ModifyTotalWidgetView extends BaseModifyDashboardWidgetView {

    private widgetChannels: DashboardChannel[];
    private template = _.template(require('templates/modals/reports/modify_widgets/totalwidget/totalwidget.html'));
    private channelsTemplate = _.template(require('templates/modals/reports/modify_widgets/totalwidget/channels.html'));
    private dateTimePickerFormat = 'MM/DD/YYYY h:mm A';
    private dailyTimeFormat = 'hh:mm A';

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.extend({
            tagName: "div",
            className: 'widget-type-channels',
            events: {
                'click .add-channel-btn': 'handleAddChannelBtnClick',

                // Chart Channel Changes
                'change .widget-channel-select-install': 'handleInstallSelectChange',
                'change .widget-channel-select-module': 'handleModuleSelectChange',
                'change .widget-channel-select-channel': 'handleChannelSelectChange',
                'change .data-range select': 'handleDataRangeChange',
                'click .widget-channel-delete': 'handleChannelDelete',
                'click .thresholds-minimized': 'handleThresholdClick',
                'input .thresholds input': 'handleThresholdsInput',
                
                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',

                // Ranges
                'change .advanced-config-checkbox': 'handleConfigToggleChange',
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleThresholdInput',
                'click .use-defaults-btn': 'handleUseDefaultsBtn',
            }
        }, options));

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);
    }

    render() {
        this.advancedConfig = !!Number(this.options.widget.getParamValue('ADVANCED_CONFIG', false));
        this.$el.html(this.template({
            dashboardCategoryCollection: this.options.dashboardCategoryCollection,
            widget: this.options.widget,
            exampleImg: require('../../../../../img/widgettypes/total/totalwidgetexample.png'),
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            report: this.options.report,
            currentUser: this.options.currentUser,
            dateTimePickerFormat: this.dateTimePickerFormat,
            dailyTimeFormat: this.dailyTimeFormat,
            timezones: new TimezoneCollection(),
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
        }));
        this.$('select').select2(Utils.Select2.defaultOptions);
        //Initialize bootstrap toggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        if (!this.options.widget.isNew()) {
            this.buildInitialChannels();
        } else {
            this.renderNewChannelRow();
        }

        this.handleDataRangeChange();
        this.setUpUIElements();

        return this;
    }

    show() {
        // Refit selects to container width after it is rendered on screen
        this.$('.channels').find('select').select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect('.category select');
    }

    checkCanSaveWidget() {
        var savable = _.filter(this.$('.widget-channel-select-channel').map(function () {
            var el = $(this);
            return el.val() || el.data('channelId');
        })).length > 0;

        this.options.parentView.setSavable(savable);
    }

    private buildInitialChannels() {
        var widgetId = this.options.widget.get('id');
        var channels = this.options.dashboardChannelCollection.where({ dashboard_widget_id: widgetId });

        // Get aggregation types for total widget
        var aggTypes = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', '').split(',');

        _.each(channels, (c: DashboardChannel) => {
            var installId = c.get('install_id');
            // Use channel's installId, rather than relying on App.getLastSelectedInstallId(), which caused errors
            var row = this.renderNewChannelRow(installId);

            function selectModuleChannel(row) {
                // Select the module
                row.find('.widget-channel-select-module').val(c.get('module_number')).trigger('change');

                // Select the channel
                row.find('.widget-channel-select-channel').val(c.get('channel_id')).trigger('change');
            }

            // Fill in the Dashboard Channel Id
            row.find('.widget-dashboard-channel-id').val(c.get('dashboard_channel_id'));

            // Select the install
            var installId = c.get('install_id');
            row.find('.widget-channel-select-install').val(installId).trigger('change');

            row.find('.widget-channel-select-channel').data('channelId', c.get('channel_id'));

            var moduleCollectionDeferred = this.options.moduleCollections[installId].getCollectionFetchPromise();
            $.when(moduleCollectionDeferred).done(() => {
                selectModuleChannel(row);
            });
            if (!this.options.moduleCollections[installId]) {
                row.hide();
            }

            // Apply aggregation types to total widget channels
            if (_.size(aggTypes)) {
                var aggType = aggTypes[Number(c.get('dashboard_channel_order'))];
                row.find('.widget-channel-select-aggregation-type').val(aggType).trigger('change');
            }
        });
    }

    private renderNewChannelRow(installId?: number) {
        var newChannelRow = $(<string>this.channelsTemplate({
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            lastSelectedInstallId: installId || App.getLastSelectedInstallId(),
            report: this.options.report,
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels
        }));
        this.$('.channels').append(newChannelRow);

        newChannelRow.find('.widget-channel-select-install').select2(Utils.Select2.defaultOptions);
        newChannelRow.find('.widget-channel-select-module').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-channel').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        this.$('.channels').find('select').select2(Utils.Select2.defaultOptions);

        // Immediately trigger a change so that preselected installs cause modules to be fetched
        newChannelRow.find('.widget-channel-select-install').trigger('change');

        this.checkCanSaveWidget();

        // Reports' Total Widgets may have a maximum of three channels,
        // so hide the add channel button after three channels have been displayed
        if (_.size(this.$('.channels').find('.channel-selects')) > 2) {
            this.$('.add-channel-btn').addClass('hidden');
        }

        return newChannelRow;
    }

    private handleAddChannelBtnClick(e) {
        e.preventDefault();

        // Don't allow user to create more than three channels for a total widget
        if (_.size(this.$('.channels').find('.channel-selects')) > 2) return;

        this.renderNewChannelRow();
    }

    private buildModuleOptions(installId) {
        var options = [];
        this.options.moduleCollections[installId].each((module) => {

            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (var i = 1; i < 5; i++) {
                var con = module.getConnector(i);
                if (con) {
                    if (con['sensor_type'] === 29) continue;

                    var mod = module.get('module_number');
                    var option = { id: mod, text: module.getDisplayName(), selected: '' };
                    if (mod === App.getLastSelectedModuleNumber()) option.selected = "selected";
                    options.push(option);
                    break;
                }
            }
        });

        if (options.length) return [{ id: '', text: '' }].concat(options);
        return [{ id: '', text: 'No Modules Found' }]
    }

    private setUpUIElements() {

        var toggleButtons = [
            { paramString: 'DAILY_TIME_MODE', className: '.daily-time-mode' }
        ];

        _.each(toggleButtons, (button) => {
            var toggleButton = this.$(<string>button.className + ' input');
            var paramValue: number = Number(this.options.widget.getParamValue(<string>button.paramString, '0'));
            var toggleCondition = paramValue >= 2;

            if (toggleCondition) {
                (<any>toggleButton).bootstrapToggle('off');
            } else {
                (<any>toggleButton).bootstrapToggle('on');
            }
        });

        // Set up date selectors for custom data range
        var from = (<any>this.$('.data-range-custom-from .date'));
        var to = (<any>this.$('.data-range-custom-to .date'));
        // And for custom daily time
        var dailyCustomStart = (<any>this.$('.daily-time-custom-from'));
        var dailyCustomEnd = (<any>this.$('.daily-time-custom-to'));

        from.datetimepicker({
            defaultDate: moment().startOf('day')
        });
        to.datetimepicker({
            defaultDate: moment().endOf('day'),
            useCurrent: false
        });
        from.on("dp.change", function (e) {
            to.data("DateTimePicker").minDate(e.date);
        });
        to.on("dp.change", function (e) {
            from.data("DateTimePicker").maxDate(e.date);
        });

        dailyCustomStart.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat
        });
        dailyCustomEnd.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat
        });
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        var moduleSelect = installSelect.parents('.channel-selects').find('.widget-channel-select-module');
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once('sync', () => {
                    moduleSelect.empty().select2(_.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions));
                    moduleSelect.trigger('change');
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId),
                }, Utils.Select2.defaultOptions));
            }
        } else {
            moduleSelect.select2(_.extend({
                disabled: !installId,
            }, Utils.Select2.defaultOptions));
        }

        moduleSelect.trigger('change');
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var moduleSelect = $(e.currentTarget);
        var moduleNumber = (<string>$(moduleSelect).val()) || "";
        var channelSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-channel');
        var installSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-install');
        var installId = (<string>$(installSelect).val());

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);

        channelSelect.empty();
        var channelOptions = [{ id: '', text: '' }];
        if (moduleNumber) {
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    var con = module.getConnector(connector);
                    if (con) {
                        var label = 'Connector ' + connector + ': ' + con['sensor_name'];
                        if (!module.showConnector(connector)) label += ' (disconnected)';

                        var optgroup = { text: label, children: [] };
                        _.each(_.sortBy(con.channels, 'channel_position'), (c) => {
                            optgroup.children.push({ id: c['channel_id'], text: c['channel_name'] });
                        });

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
            disabled: !moduleNumber.length,
            data: channelOptions,
        }, Utils.Select2.defaultOptions));
        channelSelect.trigger('change');
    }

    private handleChannelSelectChange(e: JQuery.UIEventBase) {
        var channelSelect = $(e.currentTarget);
        var container = $(channelSelect).parents('.channel-selects');
        var moduleSelect = container.find('.widget-channel-select-module');
        var moduleNumber = moduleSelect.val();
        var installSelect = container.find('.widget-channel-select-install');
        var useDefaultsButton = container.find('.use-defaults-btn');

        var channelNameInput = container.find('.widget-channel-label').val('');
        var installId = (<string>$(installSelect).val());
        var channelId = Number(channelSelect.val());

        // Clear current ranges
        const thresholdsWrapper = container.find('.thresholds-wrapper');
        thresholdsWrapper.empty();
        const channelThresholdsRow = container.find('.channel-thresholds');
        this.setMultirangeThresholdQty(channelThresholdsRow);
        useDefaultsButton.prop('disabled', true);

        if (!channelId) {
            this.updateThresholdRow(container);
            channelNameInput.prop('disabled', true);
            return;
        }

        // Enable defaults button
        useDefaultsButton.prop('disabled', false);
        var dashbordChannelId = container.find('.widget-dashboard-channel-id').val();
        var dashboardChannel = this.options.dashboardChannelCollection.findWhere({
            dashboard_channel_id: Number(dashbordChannelId),
            dashboard_widget_id: this.options.widget.get('id'),
            channel_id: channelId
        });
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var unit = channel['channel_unit'];
        var unitField = container.find('.thresholds .unit');

        if (dashboardChannel) {
            channelNameInput.val(dashboardChannel.get('dashboard_channel_name'));
            this.updateThresholdRow(container, channelId, dashboardChannel.get('rangesList'), unit);
        } else {
            this.updateThresholdRow(container, null, null, unit);
        }

        if (channelNameInput.val() == '') {
            channelNameInput.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        var chartTitleField = $('.chart-title input');
        if (chartTitleField.val() === '') {
            chartTitleField.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        channelNameInput.prop('disabled', false);
        this.checkCanSaveWidget();
        unitField.val(unit);
    }

    private handleChannelDelete(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents('.channel-selects').remove();

        // Show the add channel button again
        this.$('.add-channel-btn').removeClass('hidden');

        this.checkCanSaveWidget();
    }

    private handleThresholdsInput(e: JQuery.UIEventBase) {
        var targetInput: any = $(e.currentTarget);
        var unit = targetInput.parents('.thresholds').find('.unit').val();

        var val = (<string>targetInput.val());
        var addClass = false;
        if (val == '') {
            val = 'N/A';
        } else {
            if (_.isNaN(Number(val))) {
                val = 'N/A';
            } else {
                val += unit;
                addClass = true;
            }
        }

        var allInputs = targetInput.parents('.thresholds').find('input');
        for (var i = 0; i < allInputs.length; i++) {
            if (allInputs.eq(i).is(targetInput)) break;
        }

        var badge = targetInput.parents('.channel-thresholds').find('.threshold-badges .badge:eq(' + i + ')');
        badge.text(val);
        if (addClass) {
            if (badge.hasClass('crit-low') || badge.hasClass('crit-high')) {
                badge.addClass('danger');
            } else {
                badge.addClass('warning');
            }
        } else {
            badge.removeClass('danger').removeClass('warning');
        }
    }

    private handleThresholdClick(e: JQuery.UIEventBase) {
        var thresholdsContainer = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds');
        var hidden = thresholdsContainer.hasClass('hidden');
        if (hidden) {
            thresholdsContainer.removeClass('hidden');
        } else {
            thresholdsContainer.addClass('hidden');
        }
    }

    getChannelDifference() {
        var channelsSeen = [];
        var create = [];
        var update = {};
        var rows = this.$('.channel-selects');
        _.each(rows, (row, i) => {
            var $row = $(row);
            var channelId = $row.find('.widget-channel-select-channel').val();

            var dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
            var dashboardChannelId = Number(dashboardChannelIdField.val());

            //If the row has no channelId, make sure not to delete it if its a result of not having permissions to view an install
            if (!channelId) {
                channelId = $row.find('.widget-channel-select-channel').data('channelId');
                if (channelId) channelsSeen.push(dashboardChannelId);
                return;
            }
            channelId = Number(channelId);

            // Use default name or custom name based on configuration
            const installSelect = $row.find('.widget-channel-select-install');
            const installId = (<string>$(installSelect).val());
            const moduleNumber = $row.find('.widget-channel-select-module').val();
            const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            const channel = module.getChannelById(channelId);
            let name = (<string>$row.find('.widget-channel-label').val()).trim();
            if(!this.useCustomLabels) name = `${module.get('module_location')} - ${channel['channel_name']}`;

            var rangesList = this.advancedConfig ? this.getRangesListFromAdvancedThresholds(row) : this.getRangesListFromRegularThresholds(row);
            var upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get('id'),
                channelId: channelId,
                order: i,
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            };
            if (dashboardChannelId) {
                channelsSeen.push(dashboardChannelId);

                // Make sure we had permission to update this channel
                if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert)
            }
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    private handleDataRangeChange() {
        var dataRange = this.$('.data-range select').val();
        this.$('.data-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM);
        this.$('.daily-time-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_DAILY);
        this.$('.monthly-billing-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING);
    }

    preSave() {
        var aggregationTypesArr = _.map(this.$('.widget-channel-select-aggregation-type'), (type) => {
            return $(type).val();
        });

        var timezone = String(this.$('.timezone select').val());
        this.options.widget.setParamValue('CHART_TIMEZONE', timezone);
        var dataRange = this.$('.data-range select').val();
        this.options.widget.setParamValue('CHART_DATA_RANGE', dataRange);
        this.options.widget.setParamValue('DAILY_TIME_MODE',
            this.$('.daily-time-mode input').is(':checked')
                ? DAILY_TIME_MODE.FULL_RANGE : DAILY_TIME_MODE.UP_TO_NOW);

        var period: any = this.matchAggPeriodToDataRange(String(dataRange));

        if (dataRange === CHART_DATA_RANGE.CUSTOM) {
            var fromMoment = String(this.$('.data-range-custom-from input').val());
            var fromMomentTime = moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix();

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM', fromMomentTime
            );

            var toMoment = String(this.$('.data-range-custom-to input').val());
            var toMomentTime = moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix();
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', toMomentTime);
            period = toMomentTime - fromMomentTime;
        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        if (dataRange === CHART_DATA_RANGE.CUSTOM_DAILY) {
            var fromMoment = String(this.$('.daily-time-custom-from input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_FROM',
                // Get seconds from beginning of the day until the start time
                Math.abs(moment().startOf('day').unix() - moment(fromMoment, this.dailyTimeFormat).unix())
            );

            var toMoment = String(this.$('.daily-time-custom-to input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_TO',
                // Get seconds from beginning of the day until the end time
                Math.abs(moment().startOf('day').unix() - moment(toMoment, this.dailyTimeFormat).unix())
            );
            // Daily Custom Range always needs two days worth of data to compare
            period = 172800;
        } else {
            // If not daily custom range, remove custom times
            this.options.widget.setParamValue('DAILY_TIME_FROM', 0);
            this.options.widget.setParamValue('DAILY_TIME_TO', 0);
        }

        if (dataRange == CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            var monthlyBillingDate = String(this.$('.monthly-billing-range-custom-wrapper select').val());
            this.options.widget.setParamValue('CHART_MONTHLY_BILLING_DATE', monthlyBillingDate);
            var monthlyDateTimestamp = moment().startOf('month').add(Number(monthlyBillingDate) - 1, 'day');
            var todaysDate = moment().startOf('day').format('DD');

            var fromMoment: string;
            var toMoment: string;

            if (Number(todaysDate) >= Number(monthlyBillingDate)) {
                // If the billing period ends today or earlier, have the period end the monthly billing date this month
                toMoment = moment(monthlyDateTimestamp).tz(timezone).startOf('day').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            } else {
                // Otherwise, use the last full month's data
                toMoment = moment(monthlyDateTimestamp).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            }

            var fromMomentTS = moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix();
            var toMomentTS = moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix();

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                fromMomentTS
            );

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                toMomentTS
            );

            period = toMomentTS - fromMomentTS;
        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', aggregationTypesArr.join(','));
        this.options.widget.setParamValue('CHART_AGGREGATION_PERIOD', period);

        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);

        return true;
    }

    matchAggPeriodToDataRange(order: string) {
        switch (order) {
            case '0':
            case '1': // DAY_1
            case '7': // DAY_TODAY
            case '8': // DAY_YESTERDAY
                return '2';
            case '2': // WEEK_1
            case '9': // WEEK_CURRENT
            case '10': // WEEK_LAST
                return '3';
            case '3': // MONTH_1
            case '11': // MONTH_CURRENT
            case '12': // MONTH_LAST
                return '4';
            case '4': // MONTH_3
                return '5';
            case '5': // MONTH_6
                return '6';
            case '6': // YEAR_1
            case '13': // YEAR_CURRENT
            case '14': // YEAR_LAST
                return '7';
            case '15': // CUSTOM
                return '15';
            case '16': // CUSTOM_DAILY
                return '16';
        }
    }

    remove() {
        this.stopListening();
        return super.remove()
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/modify_widgets/ModifyTotalWidgetView.ts